import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { Provider } from "./provider.tsx";
import { initErrorTracking } from "./utils/errorTracking";
import { configureClient } from "./api/client";
import { useAuthStore } from "./store/authStore";
import "@/styles/globals.css";

// Initialize error tracking
initErrorTracking();

// Configure API client with auth store
configureClient({
  logOut: useAuthStore.getState().logout,
  updateTokens: useAuthStore.getState().updateTokens,
  getToken: useAuthStore.getState().getToken,
  getRefreshToken: useAuthStore.getState().getRefreshToken,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider>
        <App />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
